import { gql } from '@apollo/client';

type Membership = {
  organizationGlobal: string;
  roles: string[];
};

export type GetUserByIdResponse = {
  user: {
    email: string;
    firstName: string;
    lastName: string;
    roles: string[];
    tenant?: string;
    memberships?: Membership[];
  };
};

export const GET_USER_BY_ID = gql`
  query adminUserById($id: ID!) {
    user(userId: $id) {
      email
      firstName
      lastName
      roles
      tenant
      memberships {
        organizationGlobal
        roles
      }
    }
  }
`;
